<template>
    <fieldset>
        <table>
            <caption>Companies</caption>
            <thead>
                <tr>
                    <th>Company</th>
                    <th>Role</th>
                    <th>Number of Users</th>
                    <th>Options</th>
                </tr>
            </thead>
            <tbody v-if="Companies === null">
                <tr>
                    <td colspan="8" class="LoadingCell">
                        <loading-indicator /> Loading Companies
                    </td>
                </tr>
            </tbody>
            <tbody v-else>
                <tr v-for="(row, rowIndex) in TableRows" :key="rowIndex">
                    <td colspan="3" v-if="row.companyGroupName !== null">
                        <span style="cursor:pointer" @click="expandCollapseCompany(row.companyGroupName)">{{row.IsExpanded ? "▼" : "▶"}}</span>
                        {{row.companyGroupName}}
                    </td>
                    <td v-if="row.companyName !== null">
                        {{row.companyName}}
                    </td>
                    <td v-if="row.isAll">
                        <i>All</i>
                    </td>
                    <td v-if="row.customRoleName !== null">
                        {{row.customRoleName}}
                    </td>
                    <td v-if="row.totalUsers !== null">
                        {{row.totalUsers}}
                    </td>
                    <td class="Options">
                        <button v-if="row.InitialNewRoleName !== null" @click="editCompanyRole('new', false, row.InitialNewRoleName)">Add Role</button>
                        <button v-if="row.roleId !== null" @click="editCompanyRole(row.roleId, row.canEditCompanyName, null)">Manage</button>
                        <button v-if="row.roleId !== null" :disabled="row.totalUsers === 0" @click="viewCompanyRoleUsers(row.roleId)">View Users</button>
                    </td>
                </tr>
            </tbody>
        </table>
        <button @click="editCompanyRole('new', true, '')">Add New Company</button>
        <company-role v-if="selectedRoleId !== null" :roleId.sync="selectedRoleId" :InitialCompanyName="InitialCompanyName" :canEditCompanyName="canEditSelectedCompanyName" />
        <users-in-company v-if="viewUsersInRoleId !== null" :roleId.sync="viewUsersInRoleId" />
    </fieldset>
</template>

<script>
    import LoadingIndicator from './LoadingIndicator.vue';
    import CompanyRole from './CompanyRole.vue';
    import UsersInCompany from './UsersInCompany.vue'
    import $ from 'jquery';

    export default {
        name: 'Companies',
        components: {
            LoadingIndicator,
            CompanyRole,
            UsersInCompany
        },
        watch: {
            selectedRoleId: function (newValue, oldValue) {
                if (newValue === null && oldValue !== null)
                    this.loadRoles();
            }
        },
        data: function () {
            return {
                ExpandedCompanies: [],
                rawRoles: null,
                selectedRoleId: null,
                viewUsersInRoleId: null,
                canEditSelectedCompanyName: false,
                InitialCompanyName: null
            }
        },
        created: function () {
            this.loadRoles();
        },
        methods: {
            editCompanyRole: function (roleId, canEditCompanyName, InitialCompanyName) {
                this.selectedRoleId = roleId;
                this.canEditSelectedCompanyName = canEditCompanyName;
                this.InitialCompanyName = InitialCompanyName;
            },
            viewCompanyRoleUsers: function (roleId) {
                this.viewUsersInRoleId = roleId;
            },
            loadRoles: function () {
                this.rawRoles = null;
                var thisControl = this;
                $.ajax({
                    type: 'GET',
                    url: 'Roles',
                    dataType: 'json',
                    success: function (data) {
                        thisControl.rawRoles = data;
                    }

                });
            },
            expandCollapseCompany: function (company) {
                if (this.ExpandedCompanies.indexOf(company) === -1)
                    this.ExpandedCompanies.push(company)
                else
                    this.ExpandedCompanies.splice(this.ExpandedCompanies.indexOf(company), 1);
                var roles = this.rawRoles;
                this.rawRoles = [];
                this.rawRoles = roles;
            }
        },
        computed: {
            Companies: function () {
                if (this.rawRoles == null)
                    return null;
                var result = [];
                var company = null;
                for (var r = 0; r < this.rawRoles.length; r++) {
                    var role = this.rawRoles[r];
                    if (role.name.indexOf("~") == -1) {
                        company = {
                            roles: [role],
                            name: role.name
                        };
                        result.push(company);
                    }
                    else {
                        company.roles.push(role);
                    }
                }
                return result;
            },
            TableRows: function () {
                var result = [];
                var companies = this.Companies;
                for (var c = 0; c < companies.length; c++) {
                    var company = companies[c];
                    if (company.roles.length == 1) {
                        //single company
                        result.push({
                            companyGroupName: null,
                            companyName: company.roles[0].name,
                            isAll: true,
                            customRoleName: null,
                            totalUsers: company.roles[0].noOfUsers,
                            canEditCompanyName: true,
                            roleId: company.roles[0].id,
                            InitialNewRoleName: company.roles[0].name + '~'
                        });
                    }
                    else {
                        var isExpanded = this.ExpandedCompanies.indexOf(company.roles[0].name) !== -1;

                        result.push({
                            companyGroupName: company.roles[0].name,
                            companyName: null,
                            isAll: false,
                            customRoleName: null,
                            totalUsers: null,
                            'IsExpanded': isExpanded,
                            canEditCompanyName: false,
                            roleId: null,
                            InitialNewRoleName: company.roles[0].name + '~'
                        });
                        if (isExpanded) {
                            for (var r = 0; r < company.roles.length; r++) {
                                var role = company.roles[r];
                                result.push({
                                    isAll: r === 0,
                                    companyName: '',
                                    companyGroupName: null,
                                    customRoleName: r === 0 ? null : role.name.split('~')[1],
                                    totalUsers: role.noOfUsers,
                                    canEditCompanyName: false,
                                    roleId: role.id,
                                    InitialNewRoleName: null
                                })
                            }
                        }
                    }
                }
                return result;
            }
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->